import { getFileTypeFromFile } from 'lib/files';
import { logAndCaptureException, logAndCaptureMessage } from 'utils';
import { FileWithUploadRef } from 'lib/frontend/hooks/useFirebaseStorageUpload';
import getDocumentProperties from 'routes/placeScroll/helpers/getDocumentProperties';
import { ColumnService } from 'lib/services/directory';
import {
  AdTypeRecommendation,
  getAdTypeRecommendation as getAdTypeRecommendationFromProperties
} from './getAdTypeRecommendationFromProperties';

export const getAdTypeRecommendationFromFileWithUploadRef = async (
  uploadedFileAndRef: FileWithUploadRef,
  allowImages: boolean
): Promise<AdTypeRecommendation> => {
  let fileType;

  try {
    fileType = getFileTypeFromFile(uploadedFileAndRef.file);
    if (!fileType) {
      throw new Error('Unable to retrieve fileType for file upload');
    }

    const properties = await getDocumentProperties(
      uploadedFileAndRef.uploadRef,
      fileType
    );

    return getAdTypeRecommendationFromProperties(properties, allowImages);
  } catch (e) {
    const tags = {
      fileName: uploadedFileAndRef.file.name,
      fileType: fileType || 'unknown'
    };

    if (e instanceof Error && e.message.includes('Unsupported file type')) {
      logAndCaptureMessage(
        'Unsupported file type uploaded for ad type recommendation',
        tags
      );
    } else {
      logAndCaptureException(
        ColumnService.WEB_PLACEMENT,
        e,
        'Unable to retrieve liner or display recommendation',
        tags
      );
    }

    return AdTypeRecommendation.NoRecommendation;
  }
};
